import { Trans } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

export function NotFound({ children }: { children?: ReactNode }) {
	return (
		<div className="space-y-2 p-2">
			<div className="text-gray-600 dark:text-gray-400">
				{children || (
					<p>
						<Trans>The page you are looking for does not exist.</Trans>
					</p>
				)}
			</div>
			<p className="flex flex-wrap items-center gap-2">
				<button
					className="rounded-sm bg-emerald-500 px-2 py-1 text-sm font-black text-white uppercase"
					onClick={() => window.history.back()}
					type="button"
				>
					<Trans>Go back</Trans>
				</button>
				<Link
					className="rounded-sm bg-cyan-600 px-2 py-1 text-sm font-black text-white uppercase"
					to="/"
				>
					<Trans>Start Over</Trans>
				</Link>
			</p>
		</div>
	);
}
